import React from 'react'

const Introduction = () => {
    return (
        <div className='container'>
            <h1>Python</h1>
             <div class="w3-col l10 m12" id="main">
                <div id="mainLeaderboard" style={{overflow:'hidden'}}>
                  
        <div id="snhb-main_leaderboard-0"></div>

      </div>
                <h1>Python <span class="color_h1">Introduction</span></h1>
              
                <hr />

                    <h2>What is Python?</h2>
                    <p>Python is a popular programming language. It was created by Guido van Rossum,
and released in 1991.</p>

                    <p>It is used for:</p>

                    <ul>
                        <li>web development (server-side), </li>
                        <li>software development, </li>
                        <li>mathematics,</li>
                        <li>system scripting.</li>
                    </ul>

                    <h3>What can Python do?</h3>
                    <ul>
                        <li>Python can be used on a server to create web applications.</li>
                        <li>Python can be used alongside software to create workflows.</li>
                        <li>Python can connect to database systems. It can also read and modify files.</li>
                        <li>Python can be used to handle big data and perform complex mathematics.</li>
                        <li>Python can be used for rapid prototyping, or for production-ready software development.</li>
                    </ul>

                    <h3>Why Python?</h3>
                    <ul>
                        <li>Python works on different platforms (Windows, Mac, Linux, Raspberry Pi, etc).</li>
                        <li>Python has a simple syntax similar to the English language.</li>
                        <li>Python has syntax that allows developers to write programs with fewer lines than some other programming languages.</li>
                        <li>Python runs on an interpreter system, meaning that code can be executed as soon as it is written. This means that prototyping can be very quick.</li>
                        <li>Python can be treated in a procedural way, an object-oriented way or a functional way.</li>
                    </ul>

                    <h3>Good to know</h3>
                    <ul>
                        <li>The most recent major version of Python is Python 3, which we shall be using in this tutorial. However, Python 2, although not being updated with anything other than security updates, is still quite popular.</li>
                        <li>In this tutorial Python will be written in a text editor. It is possible to write Python in an Integrated Development Environment, such as Thonny, Pycharm, Netbeans or Eclipse which are particularly useful when managing larger collections of Python files.</li>
                    </ul>

                    <h3>Python Syntax compared to other programming languages</h3>
                    <ul>
                        <li>Python was designed for readability, and has some similarities to the English language with influence from mathematics.</li>
                        <li>Python uses new lines to complete a command, as opposed to other programming languages which often use semicolons or parentheses.</li>
                        <li>Python relies on indentation, using whitespace, to define scope; such as the scope of loops, functions and classes. Other programming languages often use curly-brackets for this purpose.</li>
                    </ul>

                    <div class="w3-example">
                        <h3>Example</h3>
                        <div class="w3-code notranslate pythonHigh"><span class="pythoncolor" style={{color:'black'}}>
                            <span class="pythonkeywordcolor" style={{ color: 'mediumblue' }}>print</span>(<span class="pythonstringcolor" style={{color:'brown'}}>
                                "Hello, NooB"</span>)<span class="pythonnumbercolor" style={{color:'red'}}>
                            </span> </span></div>
                        <a target="_blank" class="w3-btn w3-margin-bottom" href="trypython.asp?filename=demo_default">Try it Yourself »</a>
                    </div>




                    <br />
                  

</div>
                <article class="text">

                    <header class="article-header">
                        <h1 class="page-title">Company Views on Python</h1>
                    </header>

                    <p>Python is used successfully in thousands of real-world business
                    applications around the world, including many large and mission
critical systems.  Here are some quotes from happy Python users:</p>

<div class="section" id="youtube-com">
                        <h1>YouTube.com</h1>
                        <p>"Python is fast enough for our site and allows us to produce
                        maintainable features in record times, with a minimum of developers,"
said Cuong Do, Software Architect, <a class="reference external" href="http://youtube.com">YouTube.com</a>.</p>
                    </div>
                    <div class="section" id="industrial-light-magic">
                        <h1>Industrial Light &amp; Magic</h1>
                        <p>"Python plays a key role in our production pipeline.  Without it a
                        project the size of Star Wars: Episode II would have been very
                        difficult to pull off. From crowd rendering to batch processing to
                        compositing, Python binds all things together," said Tommy Burnette,
Senior Technical Director, <a class="reference external" href="http://www.ilm.com">Industrial Light &amp; Magic</a>.</p>
                        <p>"Python is everywhere at ILM. It's used to extend the capabilities
                        of our applications, as well as providing the glue between them. Every
                        CG image we create has involved Python somewhere in the process," said
Philip Peterson, Principal Engineer, Research &amp; Development, <a class="reference external" href="http://www.ilm.com">Industrial Light &amp; Magic</a>.</p>
                    </div>
                    <div class="section" id="google">
                        <h1>Google</h1>
                        <p>"Python has been an important part of Google since the beginning,
                        and remains so as the system grows and evolves. Today dozens of Google
                        engineers use Python, and we're looking for more people with skills in
this language." said Peter Norvig, director of search quality at <a class="reference external" href="http://google.com">Google, Inc.</a></p>
                    </div>
                    <div class="section" id="journyx">
                        <h1>Journyx</h1>
                        <p>"Journyx technology, from the source code of our software to the code that
                        maintains our Web site and ASP sites, is entirely based on Python. It
                        increases our speed of development and keeps us several steps ahead of
                        competitors while remaining easy to read and use.  It's as high level of a
                        language as you can have without running into functionality problems.  I
                        estimate that Python makes our coders 10 times more productive than Java
                        programmers, and 100 times more than C programmers." -- Curt Finch, CEO,
<a class="reference external" href="http://www.journyx.com">Journyx</a></p>
                    </div>
                    <div class="section" id="ironport">
                        <h1>IronPort</h1>
                        <p>"IronPort email gateway appliances are used by the largest
                        corporations and ISPs in the world," said Mark Peek, Sr. Director of
Engineering at <a class="reference external" href="http://www.ironport.com">IronPort Systems</a>.  "Python
is a critical ingredient in this high performance system. IronPort's
suite of products contains over a million lines of Python. The PSF is
an invaluable resource that helps keep Python on the cutting edge."</p>
                    </div>
                    <div class="section" id="eve-online">
                        <h1>EVE Online</h1>
                        <p>"Python enabled us to create <a class="reference external" href="http://www.eve-online.com/">EVE Online</a>,
a massive multiplayer game, in record
time. The EVE Online server cluster runs over 50,000 simultaneous players
in a shared space simulation, most of which is created in Python. The
flexibilities of Python have enabled us to quickly improve the game
experience based on player feedback" said
Hilmar Veigar Petursson of <a class="reference external" href="http://www.ccpgames.com/">CCP Games</a>.</p>
                    </div>
                    <div class="section" id="homegain">
                        <h1>HomeGain</h1>
                        <p>"HomeGain maintains its commitment to continual improvement through
                        rapid turnaround of new features and enhancements.  Python supports
                        this short time-to-market philosophy with concise, clear syntax and a
                        powerful standard library.  New development proceeds rapidly, and
                        maintenance of existing code is straightforward and fast," said Geoff
Gerrietts, Software Engineer, <a class="reference external" href="http://HomeGain.com">HomeGain.com</a>.</p>
                    </div>
                    <div class="section" id="thawte-consulting">
                        <h1>Thawte Consulting</h1>
                        <p>"Python makes us extremely productive, and makes
                        maintaining a large and rapidly evolving codebase relatively
simple," said Mark Shuttleworth.</p>
                    </div>
                    <div class="section" id="university-of-maryland">
                        <h1>University of Maryland</h1>
                        <p>"I have the students learn Python in our undergraduate and graduate
                        Semantic Web courses.  Why?  Because basically there's nothing else
                        with the flexibility and as many web libraries," said Prof. James
A. Hendler.</p>
                    </div>
                    <div class="section" id="eztrip-com">
                        <h1>EZTrip.com</h1>
                        <p>"The travel industry is made up of a myriad supplier data feeds all of
                        which are proprietary in some way and are constantly changing.   Python
                        repeatedly has allowed us to access, build and test our in-house
                        communications with hundreds of travel suppliers around the world in a
                        matter of days rather then the months it would have taken using other
                        languages.  Since adopting Python 2 years ago, Python has provided us
                        with a measurable productivity gain that allows us to stay competitive
                        in the online travel space," said Michael Engelhart, CTO of
<a class="reference external" href="http://www.eztrip.com">EZTrip.com</a>.</p>
                    </div>
                    <div class="section" id="realestateagent-com">
                        <h1>RealEstateAgent.com</h1>
                        <p>"Python in conjunction with PHP has repeatedly allowed us to develop
fast and proficient applications that permit <a class="reference external" href="http://www.realestateagent.com">Real Estate Agent .com</a> to operate with minimal
resources. Python is a critical part of our dynamically growing
cluster directory of real estate agents." said Gadi Hus, Webmaster,
<a class="reference external" href="http://www.volico.com/">Volico Web Consulting</a></p>
                    </div>
                    <div class="section" id="firaxis-games">
                        <h1>Firaxis Games</h1>
                        <p>"Like XML, scripting was extremely useful as both a mod tool and an
                        internal development tool.  If you don't have any need to expose code
                        and algorithms in a simple and safe way to others, you can argue that
                        providing a scripting language is not worth the effort.  However, if
                        you do have that need, as we did, scripting is a no brainer, and it
                        makes complete sense to use a powerful, documented, cross-platform
                        standard such as Python."  -- Mustafa Thamer of Firaxis Games, talking
                        about Civilization IV.  Quoted on page 18 of the August 2005
<a class="reference external" href="http://www.gdmag.com/">Game Developer Magazine</a>.</p>
                        <p>"Python, like many good technologies, soon spreads virally throughout
                        your development team and finds its way into all sorts of applications
                        and tools.  In other words, Python begins to feel like a big hammer and
                        coding tasks look like nails."
                        -- Mustafa Thamer of Firaxis Games, talking about Civilization IV.
Quoted on page 18 of the August 2005 <a class="reference external" href="http://www.gdmag.com/">Game Developer Magazine</a>.</p>
                        <p>"We chose to use python because we wanted a well-supported scripting
                        language that could extend our core code. Indeed, we wrote much more
                        code in python than we were expecting, including all in-game screens
                        and the main interface. It was a huge win for the project because
                        writing code in a language with garbage collection simply goes faster
                        than writing code in C++. The fact that users will be able to easily
                        mod the interface is a nice plus as well. The downside of python was
                        that it significantly increased our build times, mostly from linking
with Boost."</p>
                        <p>-- Soren Johnson, lead designer, Civilization IV.  Quoted
in <a class="reference external" href="http://games.slashdot.org/games/05/10/27/059220.shtml?tid=206&amp;tid=11">a Slashdot interview</a>.</p>
                    </div>


                </article>
            </div>
           
    )
}

export default Introduction
